import {
  Component,
  OnInit,
  OnDestroy,
  ViewChildren,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
  ElementRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ApiService } from 'src/app/core/services/api.service';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { Common } from 'src/app/core/constants/common';
import { LoginBase } from '../login/login-base';
import { TranslateService } from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import {HyperLink} from "../../core/constants/hyperlink";
import { UserService } from 'src/app/core/services/user.service';
import {NotificationCmsService} from '../../core/services/notification-cms.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent extends LoginBase implements OnInit, OnDestroy, AfterViewInit {
  error = '';
  subscription: Subscription;
  param: any;
  emailPattern = Common.EMAIL_PATTERN;
  @Output() changeLanguage = new EventEmitter<boolean>();
  @ViewChild('f', { static: false }) ngForm: NgForm;
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  checkEscKey = false;
  public phoneNumber: string = '';
  // 0: la trang thai reset password binh thuong
  // 1: la trang thai reset password khi het han
  // 2: la trang thai reset password khi het han nhung khong hop le (/login chua duoc goi)
  passwordExpired = 0;
  isFocusNewPassword = false;

  constructor(
    private router: Router,
    private authenSercvice: AuthenticationService,
    private apiService: ApiService,
    public notificationService: NotificationService,
    private route: ActivatedRoute,
    public message: Message,
    private toastr: ToastrService,
    private translate: TranslateService,
    public notificationCmsService: NotificationCmsService,
    private el: ElementRef,
    private userService: UserService
  ) {
    super();
    this.phoneNumber = HyperLink.PHONE_NUMBER;
  }

  currentPasswordVisibility: boolean = false;
  newPasswordVisibility: boolean = false;
  confirmPasswordVisibility: boolean = false;

  passwordData = {
    newPassword: '',
    confirmPassword: '',
    hashKey: '',
    tenantId: '',
    currentPassword: ''
  };
  tenantId;

  strengthPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~!@#$%^&*()_+|`={}[\\\]:<;?>,."\'/-]).{1,}$';
  currentLanguage = 'vi';
  notExistEmail: boolean;
  @ViewChildren('focusInput') focusInput;

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.passwordData.hashKey = params.get('hashKey');
      this.passwordData.tenantId = params.get('tenantId');
      this.tenantId = params.get('tenantId');

      this.getPasswordExpired();

      if(this.passwordExpired !== 0){
        return;
      }

      const url = `/users/check-hash-key?hashKey=${params.get('hashKey')}&tenantId=${params.get('tenantId')}`;
      this.authenSercvice.checkHashKey(this.apiService.getBaseUrl() + url).subscribe(
        res => {
          if (res && res.success === false) {
            this.router.navigate(['/reset-password-exists']);
          }
        },
        error => {
          this.toastr.success(error.message);
        }
      );
    });
    this.currentLanguage = localStorage.getItem('__language');
    if (!this.currentLanguage) {
      this.currentLanguage = 'vi';
    }
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());

    this.formChangesSubscription = this.ngForm.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    // this.notificationService.unsubscribeErrorService();
  }

  getPasswordExpired(){
    if(this.passwordData.hashKey){
      this.passwordExpired = 0;
    }
    else{
      this.passwordExpired = 1;
    }
  }



  cancel() {
    if(this.passwordExpired == 1){
      this.authenSercvice.logout();
    }
    this.router.navigate(['/enterprise-login']);
  }

  resetPwd() {
    if(this.passwordExpired === 0){
      this.resetPwdNormal();
    }
    else if(this.passwordExpired === 1){
      this.resetPwdWhenPwdExpired();
    }
  }

  resetPwdWhenPwdExpired(){
    if(this.passwordData.currentPassword == this.passwordData.confirmPassword){
      this.toastr.error(this.message.getMessage("change_password.validation.not_match"))
      return ;
    }
    this.userService.changePassword({
      currentPassword: this.passwordData.currentPassword,
      newPassword: this.passwordData.newPassword,
      confirmPassword: this.passwordData.confirmPassword
    }).subscribe((rs) => {
      if (rs && rs.success) {
        this.toastr.success(
          this.message.getMessage("change_password.change_pass_success")
        );

        if(rs.data && rs.data.dayToExpire){
          localStorage.setItem("dayToExpire", rs.data.dayToExpire)
          localStorage.setItem("passwordExpired", rs.data.passwordExpired)
        }
        this.router.navigate(['enterprise-login']);
        this.notificationCmsService.getNotification();
        // this.authenSercvice.logout();
        // this.router.navigate(['/enterprise-login'])
        //this.auth.logout();
      } else if (rs && !rs.success) {
        if (rs.code == "0x00126") {
          setTimeout(
            (_) => this.focusInput.first.nativeElement.focus(),
            200
          );
          this.toastr.error(
            this.message.getMessage("change_password.change_pass_error")
          );
        }
        if (rs.code == "0x00115") {
          setTimeout(
            (_) => this.focusInput.first.nativeElement.focus(),
            200
          );
          this.toastr.error(
            rs.data.newPassword
          );
        }
      }
    });
  }

  resetPwdNormal(){
    const url = `/users/check-hash-key?hashKey=${this.passwordData.hashKey}&tenantId=${this.tenantId}`;
    this.authenSercvice.checkHashKey(this.apiService.getBaseUrl() + url).subscribe(
      res => {
        if (res && res.success === false) {
          this.router.navigate(['/reset-password-exists']);
        }
        if (res && res.success === true) {
          this.authenSercvice.resetPassword('/users/reset-password', this.passwordData).subscribe(
            response => {
              if (response) {
                this.toastr.success(this.message.getMessage('messages.reset_password_success'));
                this.router.navigate(['/enterprise-login']);
                this.notificationCmsService.getNotification();
              }
            },
            err => console.log('oops', err)
          );
        }
      },
      error => {
        this.toastr.success(error.message);
      }
    );
  }
   /**
   * Method name: onChangeLanguage
   */
  onChangeLanguage(languageSelected: string) {
    this.currentLanguage = languageSelected;
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  enableFocus = true;

  clickVisibility(){
    console.log("click")
    this.enableFocus = false;
    this.newPasswordVisibility = !this.newPasswordVisibility;
    setTimeout(() => {
      this.enableFocus = true;

    }, 700)
  }

  isTouch = false;

  onFocus(){
    this.isTouch = true;
    if(!this.enableFocus){
      return
    }
    console.log("focus")
    setTimeout(() => {
      this.isFocusNewPassword = true;
    }, 150)
  }

  onBlur(){
    if(!this.enableFocus){
      return
    }
    console.log("blur")
    setTimeout(() => {
      this.isFocusNewPassword = false;
    }, 150)
  }

  getCurrentNameLanguage(): string{
    switch(this.currentLanguage){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Tiếng Việt'
    }
  }
  isOpen: boolean = false;
}
